module.exports = __webpack_public_path__ + "img/border-top-supporter-2.1f16b0d.svg";